/**
 * /frontend/src/features/analytics/components/bottleneck/SectionLoadRanking.js
 */

import React, { useMemo } from 'react';
import ChartContainer from '../shared/ChartContainer';
import HorizontalBarChart from '../charts/HorizontalBarChart';
import { asNumber } from '../../utils/formatters';

/**
 * Sections ranked by load score.
 * @param {{data:Array<{sectionName:string,loadScore:number}>}} props
 * @returns {JSX.Element}
 */
const SectionLoadRanking = ({ data }) => {
  const ranked = useMemo(
    () => ([...(data || [])].sort((a, b) => asNumber(b.loadScore) - asNumber(a.loadScore))),
    [data]
  );
  return (
    <ChartContainer title="Section Load Score" subtitle="Higher means worse bottleneck">
      <HorizontalBarChart data={ranked} xKey="sectionName" yKey="loadScore" />
    </ChartContainer>
  );
};

export default SectionLoadRanking;
